import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { useForm } from "react-hook-form";
import styles from "./modal.module.scss";
import { useWallets } from "@features/wallets";
import { useEffect, useState } from "react";
import { MerchantPayoutForm } from "@features/merchantBalance/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomSelect, SelectOption } from "@components/select";
import { useWithdrawals } from "@features/withdrawals";
import { WithdrawalForm } from "@features/withdrawals/api";
import * as yup from "yup";
import { errorMessage } from "@components/forms/error";
// import { useNotification } from "@hooks/use-notification";
import { Loader } from "@components/loader";
import { useMerchantBalance } from "@features/merchantBalance";
import { formatUsdt } from "@helpers/format";
import { useAuth } from "@features/auth";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  balance: number;
};

export const PayOutBalanceModal = ({
  hideModal,
  isModalOpen,
  balance,
}: Props) => {
  const payoutSchema = yup.object().shape({
    address: yup.string().required(errorMessage.required).trim(),
    amount: yup
      .number()
      .required(errorMessage.required)
      .positive()
      .max(balance),
    network: yup.string().required(errorMessage.required).trim(),
  });
  const { state: authState } = useAuth();

  // const notif = useNotification();
  const { control, handleSubmit, watch, reset } = useForm<MerchantPayoutForm>({
    resolver: yupResolver(payoutSchema),
    defaultValues: { address: "", amount: 0, network: "TRC 20" },
  });
  const { getBalances } = useMerchantBalance();
  const { state, getWallets } = useWallets();
  const [walletOptions, setWalletOptions] = useState<SelectOption[]>([]);
  const { state: withdrawalState, merchantWithdrawal } = useWithdrawals();
  const amount = watch("amount");

  useEffect(() => {
    getWallets();
  }, [getWallets]);

  useEffect(() => {
    if (state.wallets) {
      const options = state.wallets.map((wallet) => ({
        value: wallet.id,
        text: wallet.address,
      }));

      setWalletOptions(options);
    }
  }, [state.wallets]);

  const submit = async (data: MerchantPayoutForm) => {
    if (state.wallets == null) return;

    const validData: WithdrawalForm = {
      address_id: data.address,
      address:
        state.wallets.find((wallet) => wallet.id === data.address)?.address ||
        "",
      amount: data.amount,
    };

    try {
      merchantWithdrawal(validData).then(() => {
        // notif.addNotification("Успешно отправлена заявка на вывод");
        getBalances();
        hideModal();
        reset();
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      className={styles.modal}
      isOpen={isModalOpen}
      onClose={hideModal}
      title="Вывод баланса"
    >
      {withdrawalState.isWithdrawalLoading ? (
        <Loader />
      ) : (
        <form>
          <CustomSelect
            label="Адрес кошелька"
            name="address"
            control={control}
            options={walletOptions}
            placeholder="Адрес кошелька"
            classNames={{ trigger: styles.input }}
          />
          <Input
            className={styles.input}
            name="network"
            control={control}
            label="Сеть"
            disabled
          />
          <Input
            name="amount"
            control={control}
            className={styles.input}
            label="Сумма"
            type="number"
            postNote="USDT"
          />
          <div className={styles.errorNote}>
            <p>
              Комиссия за вывод средств:{" "}
              <strong>
                {formatUsdt(authState.commission_withdrawal ?? 0)}
              </strong>
            </p>
            {amount != 0 && (
              <p>{`Поступит на кошелек ${+amount - (authState.commission_withdrawal ?? 0)} USDT`}</p>
            )}
          </div>

          <Button className={styles.button} onClick={handleSubmit(submit)}>
            Готово
          </Button>
        </form>
      )}
    </Modal>
  );
};
